import styled from 'styled-components';

export const SkeletonDiv = styled.div`
  height: 100%;
  width: 100%;
`;
